import React from 'react'
import Select, { components } from 'react-select';
import {arraysEqual} from "../Filters/Utils";

const ControlComponent = props => (
  <div className={"select-wrapper select-wrapper--" + props.selectProps.selectCustomName}>
    <label id={"label-" + props.selectProps.selectCustomName} className={props.selectProps.isLabelVisible ? "visible" : "" }>{props.selectProps.selectCustomLabel}</label>
    <components.Control {...props} />
  </div>
);

const selectStyles = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    '&:hover': {
    }
  }),
  indicatorSeparator: (base, state) => {
    let additions = {};
    if (state.selectProps.showError) {
      additions.display = 'none';
    }
    return {
      ...base,
      ...additions
    }
  }
};

class CustomSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLabelVisible: false,
      selectedOption: null,
      isSelectFocused: false
    };
    this.handleLabelOnFocus = this.handleLabelOnFocus.bind(this);
  }

  componentDidMount = () => {
    let selectedOption = null;
    if (this.props.selectedValue && this.props.selectedValue !== this.state.selectedOption && this.props.selectCustomOptions.length > 1) {
      // Find the value in options.
      if (Array.isArray(this.props.selectedValue)) {
        selectedOption = [];
        for (let i = 0; i < this.props.selectedValue.length; i++) {
          for (let j= 0; j < this.props.selectCustomOptions.length; j++) {
            if (this.props.selectCustomOptions[j].value === this.props.selectedValue[i]) {
              selectedOption.push(this.props.selectCustomOptions[j]);
              break;
            }
          }
        }
        if (selectedOption.length > 0 && (!this.state.selectedOption || selectedOption.length !== this.state.selectedOption.length)) {
          this.handleChange(selectedOption);
        }
      }
      else {
        for (let i = 0; i < this.props.selectCustomOptions.length; i++) {
          if (this.props.selectCustomOptions[i].value === this.props.selectedValue) {
            selectedOption = this.props.selectCustomOptions[i];
            this.handleChange(selectedOption);
            break;
          }
        }
      }
    }
    if (this.props.selectCustomOptions.length === 1) {
      selectedOption = this.props.selectCustomOptions[0];
      if (this.props.withoutAutoSelect) {
        this.setState({ selectedOption, isLabelVisible: !!selectedOption });
      }
      else {
        this.handleChange(selectedOption);
      }
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.selectedValue && props.selectedValue !== state.selectedOption && props.selectedValue.length) {
      let selectedOption = null;
      // Find the value in options.
      if (Array.isArray(props.selectedValue)) {
        selectedOption = [];
        for (let i = 0; i < props.selectedValue.length; i++) {
          for (let j = 0; j < props.selectCustomOptions.length; j++) {
            if (props.selectCustomOptions[j].value === props.selectedValue[i]) {
              selectedOption.push(props.selectCustomOptions[j]);
              break;
            }
          }
        }
        if (selectedOption.length > 0 && (!state.selectedOption || selectedOption.length !== state.selectedOption.length)) {
          return {selectedOption, isLabelVisible: !!selectedOption || state.isSelectFocused};
        }
      }
      else {
        for (let i = 0; i < props.selectCustomOptions.length; i++) {
          if (props.selectCustomOptions[i].value === props.selectedValue) {
            selectedOption = props.selectCustomOptions[i];
            return {selectedOption, isLabelVisible: !!selectedOption || state.isSelectFocused};
          }
        }
      }
    }
    if (props.selectedValue === null) {
      let selectedOption = null;
      return {selectedOption, isLabelVisible: state.isSelectFocused};
    }
    return null;
  }

  // props.selectCustomOptions: array of key/value pairs all available options: 0-n,
  //    example: [{value: 'Batteries', label: 'Batteries'}, {value: 'Capacitors', label: 'Capacitors'}]
  getSelectedOptionFromValues = () => {
    let selectedOption = null;
    if (this.props.withoutAutoSelect) {
      return null;
    }

    if (this.props.selectCustomOptions.length === 1) {
      selectedOption = this.props.isMulti ? this.props.selectCustomOptions : this.props.selectCustomOptions[0];
    }

    if (this.props.selectCustomOptions.length > 1) {
      if (Array.isArray(this.state.selectedOption)) {
        selectedOption = this.state.selectedOption;
        selectedOption = selectedOption.filter((option) => {
          return this.isInOptions(option);
        });
      }
    }

    return selectedOption;
  }

  // helper function to determine wheter the given option is present in the selectOptions array
  isInOptions = (option) => {
    if (option === null) {
      return true;
    }
    for (let i = 0; i < this.props.selectCustomOptions.length; i++) {
      let value = Object.prototype.hasOwnProperty.call(this.props.selectCustomOptions[i], 'key') ?
        this.props.selectCustomOptions[i].key
        : this.props.selectCustomOptions[i].value;
      if (value === option.value)
        return true;
    }
    return false;
  };


  resetValue = () => {
    this.setState({selectedOption: null});
  }

  handleLabelOnFocus = (event) => {
    if (event.type === 'focus') {
      this.setState(state => ({ isSelectFocused: true }));
    }
    if (event.type === 'blur') {
      this.setState(state => ({ isSelectFocused: false }));
    }
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption, isLabelVisible: !!selectedOption });
    if (this.props.isMulti && Array.isArray(selectedOption)) {
      if (Array.isArray(selectedOption)) {
        const values = selectedOption.map(selection => selection.value);
        this.props.onSelect(this.props.selectCustomName, values);
      }
      else {
        this.props.onSelect(this.props.selectCustomName, []);
      }
    }
    else {
      const value = (selectedOption === null) ? selectedOption : selectedOption.value;
      this.props.onSelect(this.props.selectCustomName, value);
    }
  };

  formatOptionLabel = ({ value, label }) => (
    <span>
      <span className="checkbox"><span className="tick"></span></span>
      {label}
    </span>
  );

  render() {
    const {isLabelVisible, selectedOption} = this.state;
    const activeOption = selectedOption || this.getSelectedOptionFromValues();

    const {selectCustomName, selectCustomLabel, selectCustomOptions, isMulti, showError, noLowerCasePlaceholder, placeholder} = this.props;
    return (
      <Select
        {...this.props}
        value={activeOption}
        className={"react-select-container select-" + selectCustomName + (isMulti ? " select-multi" : "") + (showError ? " error" : "")}
        classNamePrefix="react-select"
        onFocus={this.handleLabelOnFocus}
        onBlur={this.handleLabelOnFocus}
        aria-labelledby={"label-" + selectCustomName}
        placeholder={ placeholder ? placeholder : selectCustomLabel}
        options={selectCustomOptions}
        isLabelVisible = {isLabelVisible}
        onChange={this.handleChange}
        components={{ Control: ControlComponent }}
        hideSelectedOptions={false}
        formatOptionLabel={isMulti ? this.formatOptionLabel : ""}
        styles={selectStyles} />
    );
  }
}

export default CustomSelect
